import { render, staticRenderFns } from "./CompNavBarMenuProfile.vue?vue&type=template&id=99725114&scoped=true&"
import script from "./CompNavBarMenuProfile.vue?vue&type=script&lang=js&"
export * from "./CompNavBarMenuProfile.vue?vue&type=script&lang=js&"
import style0 from "./CompNavBarMenuProfile.vue?vue&type=style&index=0&id=99725114&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99725114",
  null
  
)

export default component.exports